type HistoryItem = {
  created_at: string;
  type: 'login' | 'order' | 'phone_change' | 'user_change' | 'credit_transaction';
  object: any;
};

export const areAllFraudStatusesSelected = (
  selectedStatuses: Array<App.FraudStatus>,
  allStatuses: Array<App.FraudStatus>,
): boolean => selectedStatuses.length === allStatuses.length;

export const isFraudStatusFilterActive = (
  selectedStatuses: Array<App.FraudStatus>,
  allStatuses: Array<App.FraudStatus>,
): boolean => selectedStatuses.length < allStatuses.length;

export const toggleAllFraudStatuses = (
  selectedStatuses: Array<App.FraudStatus>,
  allStatuses: Array<App.FraudStatus>,
): Array<App.FraudStatus> => (areAllFraudStatusesSelected(selectedStatuses, allStatuses) ? [] : [...allStatuses]);

export const toggleFraudStatusSelection = (
  selectedStatuses: Array<App.FraudStatus>,
  allStatuses: Array<App.FraudStatus>,
  status: App.FraudStatus,
): Array<App.FraudStatus> => {
  if (areAllFraudStatusesSelected(selectedStatuses, allStatuses)) {
    return [status];
  }

  const nextSelection = selectedStatuses.includes(status)
    ? selectedStatuses.filter((selectedStatus) => selectedStatus !== status)
    : [...selectedStatuses, status];

  if (nextSelection.length === allStatuses.length) {
    return [...allStatuses];
  }

  return nextSelection;
};

export const truncateOrderId = (orderId: string): string => {
  return orderId.length > 4 ? `${orderId.substring(0, 4)}...` : orderId;
};

export const combineHistory = (
  logins: Array<any>,
  orders: Array<any>,
  userChanges: Array<any>,
  creditTransactions: Array<any> = [],
): Array<HistoryItem> => {
  const loginItems = logins.map((login) => ({
    created_at: login.login_date,
    type: 'login' as const,
    object: login,
  }));

  const orderItems = orders.map((order) => ({
    created_at: order.created_at,
    type: 'order' as const,
    object: order,
  }));

  const userItems = userChanges
    .filter((r) => !r.changed_fields.includes('toggle_name')) // toggles aren't working properly yet so ignore for now
    .map((change) => ({
      created_at: change.change_time,
      type: (change.type === 'phone_change' ? 'phone_change' : 'user_change') as HistoryItem['type'],
      object: change,
    }));

  const creditItems = creditTransactions.map((credit) => ({
    created_at: credit.created_at,
    type: 'credit_transaction' as const,
    object: credit,
  }));

  return [...loginItems, ...orderItems, ...userItems, ...creditItems].sort(
    (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
  );
};
